import React, { useState, useEffect, useCallback } from "react";
import { content } from "../assets/const/content";
import {
  Box,
  TableFooter,
  Typography,
  Popover,
  List,
  ListItemText,
  Button,
  Grid,
  AppBar, 
  Drawer,
  Toolbar,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { ReactComponent as Router } from '../assets/images/Illustration-Router.svg'
import { ReactComponent as EthernetCable } from "../assets/images/Illustration-Ethernet-Cable.svg";
import { ReactComponent as NeedHelp } from "../assets/images/need-help-subhead.svg";
import PluginRouterStep from "../assets/images/Illustration-Plug-In-Router.png"
import PhoneSetup from "../assets/images/Illustration-Phone-Setup.png";
import TPLinkAX10 from "../assets/images/TP-Link-AX-10.jpg"
import TPLinkAX21 from "../assets/images/TP-Link-AX-21.jpg"
import ASUSAX1800 from "../assets/images/ASUS-AX-1800.jpg"
import LinkSysMR7350 from "../assets/images/Linksys-MR-7350.jpg"
import fiberLogo from "../assets/images/Boingo-Fiber-Logo.svg";
import signInIcon from "../assets/images/Sign-In-Mobile.svg";
import boingoLogoWhite from "../assets/images/Boingo-Logo-White.svg";
import vectorCheck from "../assets/images/vector_checkai.png";
import setUpSubHeader from "../assets/images/setup-in-seconds-subhead.svg";
import { ReactComponent as Setup } from "../assets/images/Set-Up.svg";
import { ReactComponent as NumberOne } from "../assets/images/Number-1-Red.svg";
import { ReactComponent as NumberTwo } from "../assets/images/Number-2-Red.svg";
import { ReactComponent as NumberThree } from "../assets/images/Number-3-Red.svg";

import { LoginModal } from "../components/LoginModal";
import Header from "../components/Header";
import SetupSteps from "../components/SetupSteps";
import WelcomeFooter from "../components/WelcomeFooter";
import LinkWithQuery from "../components/LinkWithQuery";
import { Link } from "react-router-dom";
import { getSelfcareUrl } from "../config/config";
import "../assets/stylesheets/welcome.css";
import { Helmet } from "react-helmet";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box>
      <Box className="mobile-nav-container" onClick={handleDrawerToggle}>
        <img src={fiberLogo} />
        <CloseIcon className="close-icon" />
      </Box>

      <Box className="mobile-nav-sub-section">
        <Typography className="lets-start">
        </Typography>
        <LinkWithQuery to="/signup-form" className="avail-btn">
          Sign Up Now
        </LinkWithQuery>
      </Box>
      <Box className="mobile-nav-hr"></Box>
      <Box className="mobile-sign-in-wrapper">
        <a href={getSelfcareUrl(window.location.host)}>
          <img src={signInIcon} />
          Sign In
        </a>
      </Box>
    </Box>
  );

  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const handleLoginClick = () => {
    setLoginModalOpen(true);
  };

  const handleLoginClose = () => {
    setLoginModalOpen(false);
  };

  const handleLoginSuccess = useCallback((data) => {
    console.log("Authentication successful", data);
    setLoginModalOpen(true); // Close the modal

    // Use setTimeout to delay the navigation
    setTimeout(() => {
      const currentHash = window.location.hash.split("?")[0]; // Keep the '#' but remove query params
      const basePath = currentHash.split("/")[1]; // Get the second part of the path (e.g., 'afmthm')
      const newPath = `#/${basePath}/welcome`;
      window.location.hash = newPath;
    }, 2000);
  }, []);

  return (
    <>
      <AppBar
        position="fixed"
        className="app-bar"
        sx={{ backgroundColor: "rgb(44, 46, 55)" }}
      >
        <Toolbar>
          {isMobile ? (
            <>
              {/* Mobile Navigation */}
              <Grid 
                container 
                alignItems="center" 
                justifyContent="space-between" 
                className="mobile-nav"
                sx={{margin: "0 20px"}}
              >
                <Grid item xs={3} sx={{ textAlign: "left" }}>
                  <LinkWithQuery to="/" className="fiber-plan-link">
                    <img
                      src={boingoLogoWhite}
                      className="boingo-logo"
                      alt="Boingo Logo"
                    />
                  </LinkWithQuery>
                </Grid>

                <Grid item xs={3} sx={{ textAlign: "right" }}>
                  <a
                    className="my-account-link"
                    sx={{ color: "#0c93b3", }}
                    href="https://my.boingohotspot.net/login"
                    data-test-id="welcome-mobile-account-link"
                  >
                    Log In
                  </a>
                </Grid>
              </Grid>
            </>
          ) : (
            <Container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "76%",
                flexFlow: "row",
                "&.MuiContainer-root": { maxWidth: '1500px' },
              }}
            >
              <Grid
                sx={{
                  width: "auto",
                  alignSelf: "flex-start",
                }}
              >
                <Grid
                  item
                  sx={{
                    textAlign: "right",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <LinkWithQuery to="/" className="fiber-plan-link" data-test-id="welcome-header-logo">
                    <img
                      src={boingoLogoWhite}
                      className="boingo-logo"
                      alt="Boingo Logo"
                      style={{ scale: '0.88', margin: "10px 0 0 0" }}
                    />
                  </LinkWithQuery>
                </Grid>
              </Grid>
              <Grid sx={{ textAlign: "right" }}>
              </Grid>
              <Grid
                sx={{
                  justifyContent: "flex-end",
                  display: "flex",
                }}
              >
                <Grid
                  sx={{
                    display: "flex",
                    flexFlow: "row wrap",
                    alignSelf: "flex-end",
                    justifyContent: "flex-end",
                    color: "#FFF",
                    ":hover": {
                      backgroundColor: "#000"
                    }
                  }}
                >
                  <a
                    className="my-account-link"
                    href="https://my.boingohotspot.net/login"
                    data-test-id="welcome-signin-link"
                  >
                    Log in to My Account
                  </a>
                </Grid>
              </Grid>
            </Container>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar /> {/* Offset for content */}
      {/* Login Modal */}
      <LoginModal
        open={loginModalOpen}
        onClose={handleLoginClose}
        onLoginSuccess={handleLoginSuccess}
      />
    </>
  );
};

// RouterSpecsSection component
const RouterSpecsSection = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePopOverClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Box 
        sx={{
          '& .MuiTypography-root': {
            // fontSize: '16px', 
          },
        }}
      className="welcome-router-section" id="routerSection">
        <Container
          sx={{
            '&.MuiContainer-root': {
              padding: "0",
              margin: "0",
            }
          }}
        >
          <Box id="SetupInSeconds" sx={{ padding: 0, margin: 0}} className="router-header-img">
            <Typography variant="h4" fontFamily="Figtree-Bold" fontSize="28px"> 
                Set up is as easy as 1-2-3
            </Typography>
          </Box>

          <p 
            style={{ 
              textAlign: 'center',
              justifyContent: 'center',
              alignItems: 'center',
              fontSize: isMobile ? "16px" : "18px",
              padding: isMobile ? "0 11px" : "0 15px",
              lineHeight: 1.4,
              marginBottom: "60px"
            }} 
          >
            Just plug in your router, follow the set up instructions that came with it, and open a browser. <br/>You'll be automatically directed to the {isMobile && <br/>}Boingo Fiber login page.
          </p>
          <Box 
            sx={{ 
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0 20px",
              margin: isMobile ? "-26px auto 28px" : "-30px auto 40px",
              width: "80%"
            }} 
            >
              <img 
              src={PluginRouterStep} 
                style={{
                  width: isMobile ? "180px" : "210px",
                  height: "auto"
                }} 
              />
              <img 
              src={PhoneSetup} 
                style={{
                  width: isMobile ? "100px" : "120px",
                  marginLeft: "22px",
                  height: "auto"
                }} 
              />
          </Box>

          <Box className="steps-container" data-test-id="welcome-steps-container">
            <Box className="step">
              <Box className="step-img">
                <NumberOne />
              </Box>
              <Typography className="step-content">{content.routerSteps.one}</Typography>
            </Box>
            <Box className="step">
              <Box className="step-img">
                  <NumberTwo />
              </Box>
              <Typography className="step-content">{content.routerSteps.two}</Typography>
            </Box>
            <Box className="step">
              <Box className="step-img">
                  <NumberThree />
              </Box>
              <Typography className="step-content">{content.routerSteps.three}</Typography>
            </Box>
          </Box>

        </Container>
      </Box>
    </>
  );
};


export default function Welcome() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Boingo Ethernet - Welcome</title>
      </Helmet>
      <div className="fiber-welcome-container" data-test-id="welcome-container">
        <Navbar />
        <div id="welcome-header" data-test-id="welcome-header">
          <Box className="welcome-to">{content.welcomeWelcomeTo}</Box>
          <Header />
        </div>
        <Box className="container welcome" data-test-id="welcome-subheader">
          <Box className="wrapper welcome">
            <Typography
              variant="h3"
              sx={{
                fontSize: isMobile ? "16px" : "26px",
                mb: isMobile ? 1 : 1.5,
                fontFamily: "Figtree-Regular",
              }}
            >
              {content.welcomeSubhead1}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontFamily: "Figtree-Regular",
                fontSize: isMobile ? "16px" : "18px",
              }}
            >
              {content.welcomeSubhead2}
            </Typography>
          </Box>
        </Box>
        <Box
          className="what-youll-need-container"
          data-test-id="what-youll-need-container"
        >
          <Box className="what-youll-need-wrapper">
            <Box
              className="
              welcome-subhead-svg 
              gw-item 
              what-youll-need
            "
            >
              <Typography
                variant="h4"
                fontFamily="Figtree-Bold"
                className="content-section-header"
                sx={{ fontSize: "28px"}}
              >
                {content.whatYoullNeedText}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  width: "60%",
                  padding: 0,
                  margin: "40px",
                }}
                className="what-youll-need-images"
                data-test-id="what-youll-need-images"
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "column",
                    fontSize: "12px",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <Router className="router-img" />
                  <Typography fontFamily={["Figtree-Bold"]} mt={2}>
                    Router
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "column",
                    fontSize: "12px",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <EthernetCable className="ethernet-cable-img" />
                  <Typography fontFamily={["Figtree-Bold"]}>
                    An ethernet cable
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box>
              <Box className="gw-item additional">
                <p
                  style={{
                    marginTop: isMobile ? "0" : "15px",
                    padding: isMobile ? "0 14px" : "auto 24px",
                  }}
                >
                  A <Link to="/store">router</Link> allows your modem's internet signal to connect
                  wirelessly to devices throughout your room.
                </p>
              </Box>

              <Box
                className="router-images"
                sx={{
                  display: "flex",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    margin: "auto 10px 32px"
                  }}
                >
                  {/* first  */}
                  <Box sx={{ flexDirection: "row" }}>
                    <img src={TPLinkAX10} className="router-img" />
                    <Typography fontFamily={"Figtree-Bold"}>
                      TP-Link AX10
                    </Typography>
                  </Box>

                  {/* second  */}
                  <Box sx={{}}>
                    <img src={TPLinkAX21} className="router-img" />
                    <Typography fontFamily={"Figtree-Bold"}>
                      TP-Link AX21
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    mb: 3
                  }}
                >
                  {/* third */}
                  <Box sx={{}}>
                    <img src={ASUSAX1800} className="router-img" />
                    <Typography fontFamily={"Figtree-Bold"}>
                      ASUS AX1800
                    </Typography>
                  </Box>

                  {/* fourth */}
                  <Box sx={{}}>
                    <img src={LinkSysMR7350} className="router-img" />
                    <Typography fontFamily={"Figtree-Bold"}>
                      Linksys MR7350
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  margin: isMobile ? "0" : "20px auto 0",
                  textAlign: "center",
                  width: isMobile ? "100%" : "80%",
                  textAlign: "center",
                  lineHeight: "1.1",
                  fontSize: "10px",
                }}
              >
                <Typography
                  sx={{ margin: isMobile ? "30px 0 18px 0" : "0 0 18px 0" }}
                >
                  We have stress tested these systems in our labs. Have a router
                  you already love? Just make sure it meets these specs:
                </Typography>
                <List
                  sx={{
                    justifySelf: "center",
                    listStyleType: "disc",
                    margin: "-10px 0 0px 14px",
                    textAlign: "left",
                    margin: isMobile ? "20px" : "0 0 40px 0",
                  }}
                >
                  {[
                    "Supports gigabit wired speeds",
                    "Wi-Fi 5 (802.11ac) or Wi-Fi 6 (802.11ax)",
                    "80Mhz channel width",
                    "Minimum WPA2 Security",
                  ].map((text, index) => (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img className="check" src={vectorCheck} />
                      <ListItemText
                        primary={text}
                        key={index}
                        sx={{
                          "& .MuiTypography-root": {
                            fontSize: "18px",
                            lineHeight: "1.2",
                            color: "#3d434a",
                          },
                        }}
                      />
                    </Box>
                  ))}
                </List>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          className="setup-in-seconds-container"
          data-test-id="setup-container"
        >
          <Box className="setup-in-seconds-wrapper">
            <RouterSpecsSection />
          </Box>
        </Box>
        <WelcomeFooter />
      </div>
    </>
  );
}
